import n, { useState as M, useEffect as A, useMemo as V } from "react";
import { DiscountType as me } from "./index196.mjs";
import { useAtomValue as R, useSetAtom as v } from "jotai";
import { cartItemsAtom as D, amountInCartAtomCreator as F } from "./index34.mjs";
import { setBannerAtom as H } from "./index58.mjs";
import { getSelectedRateIdAtom as pe, setSelectedRateIdAtom as W } from "./index61.mjs";
import { getSelectedInsuranceAtom as de, setSelectedInsuranceAtom as ue } from "./index62.mjs";
import { PromotionPrice as fe, StandardPrice as _e } from "./index254.mjs";
import { formatPrice as L } from "./index110.mjs";
import { useHotelConfig as J } from "./index93.mjs";
import { useSelectedRate as ge } from "./index154.mjs";
import "@amenitiz/design-system";
import { track as j } from "./index9.mjs";
import { TRACK_EVENT_TYPE as G, TRACK_EVENT as Y } from "./index10.mjs";
import { getSubscriptionPlanRoot as q } from "./index14.mjs";
import { Tag as I } from "./index255.mjs";
import { RoomInput as be } from "./index226.mjs";
import { IPHONE_PRO_15_WIDTH as Q } from "./index17.mjs";
import { useMediaWatcher as X } from "./index219.mjs";
import { RateTile as Ee } from "./index256.mjs";
const Z = (e, a, l, r) => {
  const c = new Map(e);
  return l < 1 ? (c.delete(JSON.stringify({ rateId: a, isPromotion: r })), c) : (c.set(JSON.stringify({ rateId: a, isPromotion: r }), l), c);
}, ee = (e, a, l, r, c) => {
  const [b, _] = M(a), [s, u] = M(l), { setSelectedRate: E } = ge(), m = R(D), i = v(W), d = v(H), { hotelId: x, propertySize: f, propertyType: C, subscriptionPlan: k } = J();
  return A(() => {
    m.length === 0 && (u("0"), i(0));
  }, [m, i]), A(() => {
    const y = a - r + parseInt(s);
    _(y);
  }, [a, r, s]), {
    maxAmount: b,
    roomAmount: s,
    openTerms: () => {
      j(Y.CLICK, G.T_AND_C_CLICKED, {
        hotel_id: x,
        property_type: C,
        property_size: f,
        subscription_plan: q(k)
      }), E(e);
    },
    handleOnChange: (y) => {
      const N = y.toString();
      u(N), c(N), d({
        show: !1,
        message: null
      });
    }
  };
}, xe = ({
  rate: e,
  currency: a,
  noOfRooms: l,
  initialAmountInCart: r,
  totalSelectedRooms: c,
  onRateSelect: b,
  children: _,
  isDisabled: s = !1,
  handleDisabledClick: u,
  restrictViaPromocode: E = !1,
  discountType: m,
  discountValue: i
}) => {
  const { maxAmount: d, roomAmount: x, openTerms: f, handleOnChange: C } = ee(
    e,
    l,
    r,
    c,
    b
  );
  return /* @__PURE__ */ n.createElement("tr", { className: "border-b border-neutrals-15 last:border-b-0" }, /* @__PURE__ */ n.createElement("td", { className: "py-[12px] pl-[16px]" }, /* @__PURE__ */ n.createElement("div", { className: "flex flex-col gap-[4px]" }, /* @__PURE__ */ n.createElement("div", { className: "flex flex-wrap items-center gap-2" }, e && e.name ? /* @__PURE__ */ n.createElement(
    "span",
    {
      className: `text-base font-semibold ${s ? "text-neutrals-40" : "text-neutrals-90"}`
    },
    e.name.charAt(0).toUpperCase() + e.name.slice(1)
  ) : null, E ? /* @__PURE__ */ n.createElement(I, { type: "success", text: "PROMO", disabled: s }) : null, m && i ? m === me.PERCENTAGE ? /* @__PURE__ */ n.createElement(
    I,
    {
      type: "success",
      text: `-${i}%`,
      disabled: s
    }
  ) : /* @__PURE__ */ n.createElement(
    I,
    {
      type: "success",
      text: `-${L(parseFloat(i), a, !0)}`,
      disabled: s
    }
  ) : null), /* @__PURE__ */ n.createElement("div", { className: "flex flex-wrap gap-2" }, /* @__PURE__ */ n.createElement(
    I,
    {
      type: e.sales_term.modifiable ? "success" : "neutral",
      text: e.sales_term.modifiable ? I18n.t("booking_engine.results.rate.modifiable") : I18n.t("booking_engine.results.rate.non_modifiable"),
      disabled: s
    }
  ), /* @__PURE__ */ n.createElement(
    I,
    {
      type: e.sales_term.cancellable ? "success" : "neutral",
      text: e.sales_term.cancellable ? I18n.t("booking_engine.results.rate.cancellable") : I18n.t("booking_engine.results.rate.non_cancellable"),
      disabled: s
    }
  ), e.included_service ? /* @__PURE__ */ n.createElement(
    I,
    {
      type: "success",
      text: I18n.t(
        `booking_engine.results.rate.included_service.${e.included_service}`
      ),
      disabled: s
    }
  ) : null, e.sales_term.insurance_eligible ? /* @__PURE__ */ n.createElement(
    I,
    {
      type: "success",
      text: I18n.t("booking_engine.room.insurance_available"),
      disabled: s
    }
  ) : null), /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      onClick: f,
      className: `text-primary w-fit text-left text-[10px] hover:underline ${s ? "text-primary-30" : "text-primary-60"}`
    },
    I18n.t("booking_engine.information.terms_and_conditions")
  )))), /* @__PURE__ */ n.createElement("td", { className: "py-[12px]" }, /* @__PURE__ */ n.createElement("div", { className: "flex flex-col gap-2" }, _, /* @__PURE__ */ n.createElement(
    "div",
    {
      className: `text-xs font-medium ${s ? "text-neutrals-40" : "text-neutrals-70"}`
    },
    L(parseFloat(e.price_per_day), a, !0),
    "/",
    I18n.t("general.night")
  ), e.additional_charges ? /* @__PURE__ */ n.createElement(
    "span",
    {
      className: `text-[10px] font-medium ${s ? "text-neutrals-30" : "text-neutrals-70"}`
    },
    I18n.t("booking_engine.information.additional_charges")
  ) : null)), /* @__PURE__ */ n.createElement("td", { className: "py-[12px] pr-[16px] text-center" }, /* @__PURE__ */ n.createElement("div", { className: "flex justify-center" }, /* @__PURE__ */ n.createElement(
    be,
    {
      maxAmount: d,
      onChange: C,
      value: parseInt(x),
      disabled: s,
      onDisabledClick: u
    }
  ))));
}, Ie = ({
  rate: e,
  currency: a,
  noOfRooms: l,
  initialAmountInCart: r,
  totalSelectedRooms: c,
  onRateSelect: b,
  children: _,
  isDisabled: s = !1,
  handleDisabledClick: u
}) => {
  const { maxAmount: E, roomAmount: m, openTerms: i, handleOnChange: d } = ee(
    e,
    l,
    r,
    c,
    b
  );
  return /* @__PURE__ */ n.createElement(
    Ee,
    {
      rate: e,
      currency: a,
      isDisabled: s,
      handleDisabledClick: u,
      handleOnChange: d,
      roomAmount: parseInt(m),
      openTerms: i,
      noOfRooms: E
    },
    _
  );
}, te = (e) => {
  const { isBelowBreakpoint: a } = X(Q);
  return a ? /* @__PURE__ */ n.createElement(Ie, { ...e }) : /* @__PURE__ */ n.createElement(xe, { ...e });
}, z = ({
  rate: e,
  currency: a,
  roomId: l,
  noOfRooms: r,
  originalPrice: c,
  totalSelectedRooms: b,
  cityTaxIncluded: _ = !1,
  setSelectedRooms: s,
  onRateSelect: u,
  isDisabled: E = !1,
  handleDisabledClick: m,
  isMobile: i = !1
}) => {
  const d = R(
    V(
      () => F(e.id, l, !0),
      [e.id, l]
    )
  );
  A(() => {
    s(
      (f) => Z(f, e.id, d, !0)
    );
  }, [d, s, e.id]);
  const x = (f) => {
    u(f, e, e.id);
  };
  return /* @__PURE__ */ n.createElement(
    te,
    {
      isMobile: i,
      rate: e,
      currency: a,
      noOfRooms: r,
      initialAmountInCart: d.toString(),
      totalSelectedRooms: b,
      onRateSelect: x,
      isDisabled: E,
      handleDisabledClick: m,
      discountType: e.discount_type,
      discountValue: e.discount_value
    },
    /* @__PURE__ */ n.createElement(
      fe,
      {
        price: e.total_price,
        currency: a,
        originalPrice: c,
        cityTaxIncluded: _
      }
    )
  );
}, U = ({
  rate: e,
  currency: a,
  roomId: l,
  noOfRooms: r,
  totalSelectedRooms: c,
  cityTaxIncluded: b = !1,
  setSelectedRooms: _,
  onRateSelect: s,
  isDisabled: u = !1,
  handleDisabledClick: E,
  restrictViaPromocode: m = !1,
  isMobile: i = !1
}) => {
  const d = R(
    V(
      () => F(e.id, l, !1),
      [e.id, l]
    )
  );
  A(() => {
    _(
      (f) => Z(f, e.id, d, !1)
    );
  }, [d, _, e.id]);
  const x = (f) => {
    s(f, e, e.id, e.restrict_via_promocode);
  };
  return /* @__PURE__ */ n.createElement(
    te,
    {
      isMobile: i,
      rate: e,
      currency: a,
      noOfRooms: r,
      initialAmountInCart: d.toString(),
      totalSelectedRooms: c,
      onRateSelect: x,
      isDisabled: u,
      handleDisabledClick: E,
      restrictViaPromocode: m
    },
    /* @__PURE__ */ n.createElement(
      _e,
      {
        price: e.total_price,
        currency: a,
        cityTaxIncluded: b,
        isDisabled: u
      }
    )
  );
}, Ve = ({
  rates: e,
  currency: a,
  roomId: l,
  noOfRooms: r,
  motherId: c,
  motherName: b,
  merchantId: _,
  cityTaxIncluded: s = !1,
  onRateSelect: u
}) => {
  const [E, m] = M(/* @__PURE__ */ new Map()), [i, d] = M(0), x = R(pe), f = v(W), C = R(de), k = v(ue), h = R(D), O = v(H), { hotelId: y, propertySize: N, propertyType: ne, subscriptionPlan: se } = J(), { isBelowBreakpoint: ae, hasEvaluatedView: le } = X(Q);
  A(() => {
    const t = E.values();
    let o = 0;
    for (; ; ) {
      const p = t.next();
      if (p.done)
        break;
      o += p.value;
    }
    d(o);
  }, [E]);
  const w = (t, o, p, g) => {
    p ? u(t, o, p, g) : u(t, o, void 0, g), t === "0" && h.length - i === 0 ? (f(0), k(!1)) : (f(o.sales_term.id), k(o.sales_term.insurance_eligible));
  }, oe = (t) => x > 0 ? x !== t : !1, re = _ ? h.some(
    (t) => t.merchantId && t.merchantId !== _
  ) : !1, $ = c ? h.some((t) => t.roomId == c) : !1, K = h.some(
    (t) => t.motherId && t.motherId == l
  ), ie = (t) => {
    var o;
    return (o = e.find(
      (p) => {
        var g;
        return ((g = p.promotions) == null ? void 0 : g.some((S) => S.sales_term.id === t)) || p.sales_term.id === t;
      }
    )) == null ? void 0 : o.sales_term.insurance_eligible;
  }, ce = (t) => {
    const o = ie(t);
    return h.length > 0 && o !== C;
  }, T = (t) => oe(t) || $ || K || re || ce(t), P = () => {
    j(Y.CLICK, G.DISABLED_RATE_CLICKED, {
      hotel_id: y,
      property_type: ne,
      property_size: N,
      subscription_plan: q(se)
    });
    let t = I18n.t("booking_engine.information.multi_rates_banner");
    $ ? t = I18n.t("booking_engine.information.cottage_in_cart", {
      name: b || ""
    }) : K && (t = I18n.t("booking_engine.information.cottage_room_in_cart", {
      name: b || ""
    })), O({
      show: !0,
      message: t
    });
  };
  return le ? ae ? /* @__PURE__ */ n.createElement("div", { className: "mt-6 flex flex-col gap-4" }, e.map(
    ({ id: t, promotions: o, total_price: p }) => o.map((g) => /* @__PURE__ */ n.createElement(
      z,
      {
        key: g.id,
        isMobile: !0,
        rate: g,
        currency: a,
        roomId: l,
        noOfRooms: r,
        originalPrice: p,
        totalSelectedRooms: i,
        setSelectedRooms: m,
        cityTaxIncluded: s,
        onRateSelect: (S, B) => {
          w(S, B, t);
        },
        isDisabled: T(g.sales_term.id),
        handleDisabledClick: P
      }
    ))
  ), e.map((t) => /* @__PURE__ */ n.createElement(
    U,
    {
      key: t.name,
      isMobile: !0,
      rate: t,
      currency: a,
      roomId: l,
      noOfRooms: r,
      totalSelectedRooms: i,
      setSelectedRooms: m,
      cityTaxIncluded: s,
      onRateSelect: (o, p) => {
        w(
          o,
          p,
          void 0,
          t.restrict_via_promocode
        );
      },
      isDisabled: T(t.sales_term.id),
      handleDisabledClick: P,
      restrictViaPromocode: t.restrict_via_promocode
    }
  ))) : /* @__PURE__ */ n.createElement("div", { "data-testid": "rates", className: "mt-6 w-full overflow-hidden" }, /* @__PURE__ */ n.createElement("table", { className: "w-full border-collapse border border-neutrals-15 bg-white" }, /* @__PURE__ */ n.createElement("thead", null, /* @__PURE__ */ n.createElement("tr", { className: "bg-neutrals-10 text-xs text-neutrals-70" }, /* @__PURE__ */ n.createElement("th", { className: "w-[45%] py-[6px] pl-[16px] text-left font-semibold" }, I18n.t("booking_engine.results.rate.name").toUpperCase()), /* @__PURE__ */ n.createElement("th", { className: "w-[45%] py-[6px] text-left font-semibold" }, I18n.t("booking_engine.results.rate.today_price").toUpperCase()), /* @__PURE__ */ n.createElement("th", { className: "w-[10%] min-w-[130px] py-[6px] pr-[16px] text-center font-semibold" }, I18n.t("booking_engine.results.rate.select_rooms").toUpperCase()))), /* @__PURE__ */ n.createElement("tbody", null, e.map(
    ({ id: t, promotions: o, total_price: p }) => o.map((g) => /* @__PURE__ */ n.createElement(
      z,
      {
        key: g.id,
        rate: g,
        currency: a,
        roomId: l,
        noOfRooms: r,
        originalPrice: p,
        totalSelectedRooms: i,
        setSelectedRooms: m,
        cityTaxIncluded: s,
        onRateSelect: (S, B) => {
          w(S, B, t);
        },
        isDisabled: T(g.sales_term.id),
        handleDisabledClick: P
      }
    ))
  ), e.map((t) => /* @__PURE__ */ n.createElement(
    U,
    {
      key: t.name,
      rate: t,
      currency: a,
      roomId: l,
      noOfRooms: r,
      totalSelectedRooms: i,
      setSelectedRooms: m,
      cityTaxIncluded: s,
      onRateSelect: (o, p) => {
        w(
          o,
          p,
          void 0,
          t.restrict_via_promocode
        );
      },
      isDisabled: T(t.sales_term.id),
      handleDisabledClick: P,
      restrictViaPromocode: t.restrict_via_promocode
    }
  ))))) : null;
};
export {
  Ve as Rates
};
